import { useState, useEffect, useRef } from "react";
import { Modal } from "react-bootstrap";
import servicosMotivo from "../../servicos/servicos-motivo";
import { Form } from "semantic-ui-react";
import MenuLateral from "../components/MenuLateral";
import NavMenu from "../components/Nav";
import { ToastContainer, toast } from "react-toastify";
import Edit from "../../img/svgs/Edit";
import Cancel from "../../img/svgs/Cancel";
import Salvar from "../../img/svgs/Salvar";
import { DataGrid } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import { localizedTextsMap } from "../../utils/localizedTextsMap";

const ListMotivos = () => {
  const [motivos, setMotivos] = useState([]);
  const [valor, setValor] = useState();
  const [editado, setEditado] = useState(false)
  const [show, setShow] = useState(false);
  const containerRef = useRef(null);
  const [idMotivo, setIdMotivo] = useState();
  const descricao = useRef();
  const qtd_milhas = useRef();
  const handleClose = () => setShow(false);


  useEffect(() => {
    function getDados() {
      servicosMotivo.listarTodos()
        .then(response => {
          if (response.status === 200) {
            setMotivos(response.data);
          }
        }).catch((error) => {
          console.log(error);
        });
    }
    getDados();
  }, [editado]);

  const editarMotivo = () => {
    setEditado(false);
    const data = {
      "descricao": descricao?.current.value,
      "qtd_milhas": qtd_milhas?.current.value,
    }
    servicosMotivo.editar(idMotivo, data).then(response => {
      if (response.status === 200) {
        setEditado(true);
        toast.success('Edição efetuada com sucesso!')
      } else {
        toast.error('Não foi possível efetuar alteração solicitada!')
      }
    })
    handleClose()
  }

  const handleShow = (motivo) => {
    setValor(motivo);
    setIdMotivo(motivo.id_motivo);
    setShow(true);
  }

  const columnsMotivo = [
    { field: "id_motivo", headerName: "ID", width: 45 },
    {
      field: "descricao",
      headerName: "Descrição",
      width: 250,
      editable: true,
    },
    {
      field: "qtd_milhas",
      headerName: "Qtd de Milhas",
      width: 150,
      editable: true,
    },
    {
      field: "editar",
      headerName: "Editar",
      width: 90,
      renderCell: (params) => {
        return <button className="btn-icones rounded p-1" size="sm" onClick={() => handleShow(params.row)}><Edit /> Editar</button>
      }
    }
  ];
  const ModalEditar = () => {
    return <>
      <Modal className="modal-mae  modal-lg" show={show} onHide={handleClose}>
        <Modal.Body className="modal-edicao" >
          <div ref={containerRef}>
            <Form>
              <div className="d-flex justify-content-center">
                <div>
                  <Form.Field className="mx-5">
                    <label htmlFor="descricao" className="form-label label-texto">Descrição</label>
                    <input className="input-cadastro" defaultValue={valor?.descricao} ref={descricao}></input>
                  </Form.Field>
                  <Form.Field className="mx-5">
                    <label htmlFor="qtd_milhas" className="form-label label-texto">Qtd de Milhas</label>
                    <input className="input-cadastro" defaultValue={valor?.qtd_milhas} ref={qtd_milhas}></input>
                  </Form.Field>
                  <div className="text-center">
                    <button className="btn-icones rounded p-1 w-25" variant="primary" onClick={editarMotivo}>
                      <Salvar /> Salvar
                    </button>
                    <button className="btn-icones rounded p-1 w-25 ms-2" variant="secondary" onClick={handleClose}>
                      <Cancel /> Cancelar
                    </button>
                  </div>
                </div>
              </div>
            </Form>
          </div>
        </Modal.Body>
      </Modal>
    </>
  }
  return (
    <>
      <NavMenu />
      <ToastContainer />
      <div className="d-flex container">
        <div className="w-25">
          <MenuLateral />
        </div>
        <div className="w-75 tabelas-gerenciais">
          <ModalEditar />
            <h3 className="text-start subtitulo" style={{fontSize: 20}}>Lista de Motivos</h3>

            <Box sx={{ height: 650, width: 950, marginTop: 2 }}>
              <DataGrid

                style={{ borderRadius: "20px" }}
                localeText={localizedTextsMap}
                rows={motivos}
                columns={columnsMotivo}
                pageSize={10}
                rowsPerPageOptions={[10]}
                disableSelectionOnClick
                getRowId={(row) => row.id_motivo}
                getRowClassName={(params) =>
                  params.indexRelativeToCurrentPage % 2 === 0 ? 'Mui-even' : 'Mui-odd'
                }
              />
            </Box>
          


        </div>
      </div>
    </>
  );
};

export default ListMotivos;